const awaiter = (ms = 300) => new Promise<void>((resolve) => {
    setTimeout(() => {
        resolve();
    }, ms);
});

export default awaiter;
